let $ = require("jquery");
let Backbone = require("backbone");
let _ = require("underscore");
import i18n from "../../utils/i18n";

let PurchaseHistoryListView = require("./PurchaseHistoryListView.js");
import pos from "../../POS.js";

let main = function (Backbone, _, i18n, PurchaseHistoryListView, pos) {
    return Backbone.View.extend({

        events: {
            "click .feature a": "onSelectFeature",
            "click .history a": "onSelectHistory",
            "click .add-btn": "_pricing"
        },

        initialize: function (options) {
            this.rId = this.$el.data("id");
            //this.featureListView = new FeatureListView({el: this.$(".subContent"), model: new Backbone.Model({organizationId: this.rId})});
            this.purchaseHistoryListView = new PurchaseHistoryListView({
                el: this.$(".subContent"),
                model: new Backbone.Model({organizationId: this.rId})
            });
        },

        render: function () {
            var self = this;
            if (!pos.checkFeature("BASE")) {
                if (pos.get("branded")) {
                    alert(i18n.msg("pos.settings.invalid.brandedlicense"));
                    window.location.href = "/logout";
                }
            }
            self.onSelectHistory();
            return this;
        },

        onSelectHistory: function (event) {
            this.$("li.tab").removeClass("active");
            this.$("li.tab.history").addClass("active");
            this.purchaseHistoryListView.render();
        }
    });
};

let exportedValue = main(Backbone, _, i18n, PurchaseHistoryListView, pos);
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/settings/LicenseSettingView.js